'use client';

import { useEffect, useState } from 'react';
import { Loader } from '@heathmont/moon-core-tw';
import Translate from '~/client/shared/i18n/Translate';
import WithdrawalTickerDesktop from '../Layout/WithdrawalTickerDesktop';
import WithdrawalTickerMobile from '../Layout/WithdrawalTickerMobile';
import getWithdrawalStats from '@/actions/getWithdrawalStats';

const REFRESH_INTERVAL = 10000;

type Stat = {
  time: string;
  value: number;
};

const WithdrawalTickerContainer: FC = () => {
  const [statValues, setStatValues] = useState<Stat[]>([]);
  const [lastUpdatedTimes, setLastUpdatedTimes] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setError] = useState(false);

  useEffect(() => {
    const loadStats = async () => {
      const { stats: newStats, error = false } = await getWithdrawalStats();

      setStatValues((prevStats) => {
        if (prevStats.length === 0) {
          return newStats;
        }

        const updatedStats = prevStats.map((prevStat) => {
          const matchingNewStat = newStats.find(
            (stat) => stat.time === prevStat.time,
          );
          return matchingNewStat
            ? { ...prevStat, value: matchingNewStat.value }
            : prevStat;
        });

        const updatedTimes = updatedStats
          .filter(
            (updatedStat, index) =>
              updatedStat.value !== prevStats[index].value,
          )
          .map((stat) => stat.time);

        setLastUpdatedTimes(updatedTimes);
        setTimeout(() => setLastUpdatedTimes([]), 1000);

        return updatedStats;
      });

      setError(error);
      setIsLoading(false);
    };

    loadStats();
    const interval = setInterval(loadStats, REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, [isError]);

  if (isError) {
    return null;
  }

  if (isLoading) {
    return (
      <div className="grid place-items-center gap-4 ">
        <Loader />
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <div className="font-light font-headline text-moon-24">
          <Translate id="wd.ticker.title" />
        </div>
      </div>

      <div className="lg:hidden">
        <WithdrawalTickerMobile
          stats={statValues}
          lastUpdatedTimes={lastUpdatedTimes}
          setStatValues={setStatValues}
        />
      </div>

      <div className="hidden lg:block">
        <WithdrawalTickerDesktop
          stats={statValues}
          lastUpdatedTimes={lastUpdatedTimes}
          setStatValues={setStatValues}
        />
      </div>
    </div>
  );
};

export default WithdrawalTickerContainer;
